export default __webpack_public_path__ + "static/landshaft-logo-1200-900-47d7b73ddd966a4a0a883fe480088357.jpg";